window.LC = {
    APP_MODE: "dev",
    LC_HOST: "localhost:8080",
    SERVER_API_URL: "http://localhost:47219/api",
    RAPID_SERVER_URL: "http://localhost:50482",
    WEBSITE_URL: "http://localhost:54033",
    GOOGLE_ANALYTICS_KEY: "G-8XCV6M68W7",
    GOOGLE_MAP_API_KEY: 'AIzaSyCjgFOleRhn6Lffd8VW3y29N99bSgCCAT8',
    INTRO_COURSE_NAME: "An Introduction to California Surplus Line Regulation",
    WEBINAR_LOCATION_NAME: "WEBINAR",
};